export const warehouse = {
  title: 'Warehouse Management',
  subtitle: 'Manage warehouses and storage locations',
  
  tab: {
    warehouses: 'Warehouses',
    locations: 'Locations'
  },
  
  list: {
    title: 'Warehouses',
    empty: 'No warehouses created yet',
    search: 'Search warehouses',
    create: 'Create new warehouse',
    edit: 'Edit warehouse',
    delete: 'Delete warehouse',
    deleteConfirmation: 'Are you sure you want to delete this warehouse?'
  },
  
  fields: {
    name: 'Warehouse name',
    code: 'Warehouse code',
    location: 'Address',
    description: 'Notes',
    isActive: 'Active',
    isDefault: 'Default warehouse',
    status: 'Status'
  },
  
  create: 'New warehouse',
  edit: 'Edit warehouse',
  default: 'Default',
  hasInventory: 'Contains inventory',
  
  locations: {
    title: 'Storage locations',
    empty: 'No storage locations in this warehouse',
    create: 'New location',
    edit: 'Edit location',
    delete: 'Delete location',
    deleteConfirmation: 'Are you sure you want to delete this location?',
    comingSoon: 'Location management will be available soon'
  },
  
  success: {
    created: 'Warehouse successfully created',
    updated: 'Warehouse successfully updated',
    deleted: 'Warehouse successfully deleted'
  },
  
  error: {
    create: 'Error occurred while creating warehouse',
    update: 'Error occurred while updating warehouse',
    delete: 'Error occurred while deleting warehouse',
    notFound: 'Warehouse not found',
    cannotDeleteWithInventory: 'Cannot delete warehouse because it contains inventory records',
    cannotDeleteWithHistory: 'Cannot delete warehouse because it contains inventory movement history'
  }
}; 